import { lazy } from 'react';

export const LazyJoinTeamPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--join-team-page" */ './join-team-page'
    ),
);
